export default __webpack_public_path__ + "static/media/icono-otras-funciones.e9976946.svg";